import React from "react";
import { Row, Col, NavLink } from "react-bootstrap";

// Import local gallery images so webpack bundles them correctly
import g1 from "../../assets/images/home/event_gallary_1.png";
import g2 from "../../assets/images/home/event_gallary_2.png";
import g3 from "../../assets/images/home/event_gallary_3.png";
import g4 from "../../assets/images/home/event_gallary_4.png";
import g5 from "../../assets/images/home/event_gallary_5.png";
import g6 from "../../assets/images/home/event_gallary_6.png";
import { Link } from "react-router-dom";

export default function EventGallery() {
  return (
    <section className="event-gallery my-5">
      {/* Title Row */}
      <div className="d-flex justify-content-center align-items-center text-center team-header mb-4">
        <div className="d-flex justify-content-center align-items-center flex-column ms-auto">
          <h2 className="team-title mb-2 h1">Event Gallery</h2>
        </div>
        <NavLink as={Link} to="event-gallery" className="view-all-link ms-auto">
          View All
        </NavLink>
      </div>

      <Row className="g-3">
        {/* {images.map(img => (
          <Col key={img.id} xs={12} md={6} lg={3}>
            <div className="gallery-item position-relative overflow-hidden" style={{ borderRadius: '12px', height: '180px' }}>
              <img 
                src={img.src} 
                alt={img.alt}
                className="w-100 h-100" 
                style={{ 
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            </div>
          </Col>
        ))} */}
        <Col xs={12} md={6} lg={3}>
          <div className="gallery-item position-relative overflow-hidden mb-3 h-310">
            <img
              src={g1}
              alt="Cultural Performance"
              className="w-100 h-100"
            />
          </div>
          <div className="gallery-item position-relative overflow-hidden ">
            <img
              src={g2}
              alt="Cultural Performance"
              className="w-100 h-100"
            />
          </div>
        </Col>
        <Col xs={12} md={6} lg={3}>
          <div className="gallery-item position-relative overflow-hidden h-100">
            <img
               src={g3}
              alt="Cultural Performance"
              className="w-100 h-100 object-fit-cover"
            />
          </div>
        </Col>
        <Col xs={12} md={6} lg={3}>
          <div className="gallery-item position-relative overflow-hidden">
            <img
               src={g4}
              alt="Cultural Performance"
              className="w-100 h-100"
            />
          </div>

          <div className="gallery-item position-relative overflow-hidden h-310 mt-3">
            <img
               src={g5}
              alt="Cultural Performance"
              className="w-100 h-100"
            />
          </div>
        </Col>
        <Col xs={12} md={6} lg={3}>
          <div className="gallery-item position-relative overflow-hidden h-100">
            <img
               src={g6}
              alt="Cultural Performance"
              className="w-100 h-100 object-fit-cover"
            />
          </div>
        </Col>
      </Row>
    </section>
  );
}






// export default function EventGallery({ eventGalleryList, loading }) {

//   console.log("Galleriedefde",eventGalleryList)

//   const [g1, g2, g3, g4, g5, g6] = eventGalleryList || [];

//   return (
//     <section className="event-gallery my-5">
//       {loading || !eventGalleryList || eventGalleryList.length < 7 ? (
//         <div className="d-flex justify-content-center align-items-center">
//           <Skeleton height={600} width={1200} borderRadius={12} />
//         </div>
//       ) : (
//         <>
//           <div className="d-flex justify-content-center align-items-center text-center team-header mb-4">
//             <div className="d-flex justify-content-center align-items-center flex-column ms-auto">
//               <h2 className="team-title mb-2 h1">Event Gallery</h2>
//             </div>
//             <NavLink href="#" className="view-all-link ms-auto">
//               View All
//             </NavLink>
//           </div>

//           <Row className="g-3">
//             <Col xs={12} md={6} lg={3}>
//               <div className="gallery-item position-relative overflow-hidden mb-3 h-310">
//                 <img
//                   src={`${IMAGE_BASEURL}${g1?.cover_image_path}`}
//                   alt={g1?.title}
//                   className="w-100 h-100"
//                 />
//               </div>
//               <div className="gallery-item position-relative overflow-hidden ">
//                 <img
//                   src={`${IMAGE_BASEURL}${g2?.cover_image_path}`}
//                   alt={g2?.title}
//                   className="w-100 h-100"
//                 />
//               </div>
//             </Col>
//             <Col xs={12} md={6} lg={3}>
//               <div className="gallery-item position-relative overflow-hidden h-100">
//                 <img
//                   src={`${IMAGE_BASEURL}${g3?.cover_image_path}`}
//                   alt={g3?.title}
//                   className="w-100 h-100 object-fit-cover"
//                 />
//               </div>
//             </Col>
//             <Col xs={12} md={6} lg={3}>
//               <div className="gallery-item position-relative overflow-hidden">
//                 <img
//                   src={`${IMAGE_BASEURL}${g4?.cover_image_path}`}
//                   alt={g4?.title}
//                   className="w-100 h-100"
//                 />
//               </div>

//               <div className="gallery-item position-relative overflow-hidden h-310 mt-3">
//                 <img
//                   src={`${IMAGE_BASEURL}${g5?.cover_image_path}`}
//                   alt={g5?.title}
//                   className="w-100 h-100"
//                 />
//               </div>
//             </Col>
//             <Col xs={12} md={6} lg={3}>
//               <div className="gallery-item position-relative overflow-hidden h-100">
//                 <img
//                   src={`${IMAGE_BASEURL}${g6?.cover_image_path}`}
//                   alt={g6?.title}
//                   className="w-100 h-100 object-fit-cover"
//                 />
//               </div>
//             </Col>
//           </Row>
//         </>
//       )}
//     </section>
//   );
// }
